import React from "react";
import FinanzasCompleto from "../components/FinanzasCompleto";

export default function FinanzasPage({ user }) {
  return <FinanzasCompleto user={user} />;
}